import { eur } from "@/lib/format";
import { num, fechaEs } from "../utils";
import { TotalesCert } from "../TotalesCert";

const periodoTxt = (v) => {
  const rango = v.periodo_desde && v.periodo_hasta ? `del ${fechaEs(v.periodo_desde)} al ${fechaEs(v.periodo_hasta)}` : "";
  return [rango, v.periodo].filter(Boolean).join(" · ");
};

function Partida({ p }) {
  return (
    <div className="px-4 py-3 sm:px-5">
      <p className="break-words text-sm text-slate-800">{p.codigo && <span className="mr-1.5 font-mono-num text-xs text-slate-400">{p.codigo}</span>}{p.descripcion}</p>
      <div className="mt-1.5 grid grid-cols-2 gap-x-4 gap-y-1 text-xs sm:grid-cols-4">
        <p><span className="block text-slate-500">Presupuestado</span><span className="font-mono-num">{num(p.cantidad_presupuesto)} {p.unidad}</span></p>
        <p><span className="block text-slate-500">A origen</span><span className="font-mono-num">{num(p.cantidad_origen)} {p.unidad}</span></p>
        <p><span className="block text-slate-500">Este periodo</span><span className="font-mono-num">{num(p.cantidad_periodo)} {p.unidad}</span></p>
        <p><span className="block text-slate-500">Importe periodo</span><span className="font-mono-num font-bold text-slate-900">{eur(p.importe_periodo)}</span></p>
      </div>
    </div>
  );
}

export function DocumentoCert({ v }) {
  let cap = null;
  const periodo = periodoTxt(v);
  return (
    <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid="cert-publica-documento">
      <div className="border-b border-slate-100 px-4 py-4 sm:px-5">
        <h1 className="font-heading text-xl font-extrabold text-[#1B2B4B]">Certificación n.º {v.orden} · <span className="font-mono-num">{v.numero}</span></h1>
        <p className="text-sm text-slate-600">Obra: <b>{v.obra}</b> · Cliente: {v.cliente_nombre} · Presupuesto {v.presupuesto_numero}</p>
        <p className="text-xs text-slate-500">Fecha: {fechaEs(v.fecha)}{periodo ? ` · Periodo: ${periodo}` : ""}</p>
      </div>
      <div className="divide-y divide-slate-100">
        {v.partidas.map((p, i) => {
          const cabecera = p.capitulo !== cap;
          cap = p.capitulo;
          return <div key={p.partida_id || i}>{cabecera && <p className="bg-slate-50 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#1B2B4B] sm:px-5">{p.capitulo || "Trabajos"}</p>}<Partida p={p} /></div>;
        })}
      </div>
      <div className="border-t border-slate-100 px-4 py-4 sm:px-5">
        <TotalesCert t={v} prefijo="cert-publica" totalId="cert-publica-total" />
      </div>
      {v.condiciones?.isp && <p className="border-t border-slate-100 px-4 py-3 text-xs text-slate-500 sm:px-5">Operación con inversión del sujeto pasivo conforme al art. 84.Uno.2º.f) de la Ley 37/1992, del IVA.</p>}
      {v.notas && <p className="border-t border-slate-100 px-4 py-3 text-sm text-slate-600 sm:px-5"><b>Observaciones:</b> {v.notas}</p>}
    </section>
  );
}
